import Vue from "vue";
import axios from "axios";
import Api from "./api";
import Qs from "qs";
import store from "../store";
import router from "../router";
import { Toast } from 'vant';
let vm = new Vue({
  store,
  router,
});
axios.defaults.withCredentials = true

const common = {
  // url, methods, params, callback, loadFlag = true
  request(options) {
    let {
      url,
      methods,
      params,
      callback,
      loadFlag
    } = options;

    // vm.$loading.show();
    const toast = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: '加载中...',
    });
    let Params = params || {};
    // Params.token = vm.$store.state.token
    if (methods == "post") {
      Params = Qs.stringify(Params);
    }
    axios({
      method: methods.toLowerCase(),
      url: Api[url],
      data: methods == "post" ? Params : {},
      params: methods == "get" ? params : {},
      withCredentials: true,
      headers: {
        // "Authorization": localStorage.getItem('token') ? localStorage.getItem('token') : "yE52WwOPnj78rYCH"
        "Authorization": localStorage.getItem('token') ? localStorage.getItem('token') : ""
      }
    }).then((res) => {
      // vm.$loading.hide();
      Toast.clear();
      if (res.data.errcode == 0) {
        callback(res);
      }
      else if (res.data.errcode == 101) {
        var ua = window.navigator.userAgent.toLowerCase();
        // //通过正则表达式匹配ua中是否含有MicroMessenger字符串
        if (ua.search("zhqd") != -1 || ua.search("zhihuiqingdaoapp") != -1 || ua.search("zhqdapp") != -1) {
          zhqdJsApp.login()
        } else {
          window.location.href = 'http://city.shiminjia.com/api/sly_goods/auth'
        }
      } else {
        Toast(res.data.errmsg)
        callback(res);
      }
    }).catch((err) => {
      // vm.$loading.hide();
      Toast.clear();
    });
  },
  getToken(callback) {
    if (this.getQueryVariable('token')) {
      let token = this.getQueryVariable('token')
      localStorage.setItem('token', token)
      let pid = this.getQueryVariable('pid')
      if (pid) {
        localStorage.setItem('pid', pid)
      }
      callback();
    } else {
      localStorage.removeItem('token')
      let pid = this.getQueryVariable('pid')
      localStorage.removeItem('pid')
      if (pid) {
        window.location.href = "http://app.shiminjia.com/library/questions/auth?pid=" + pid
      } else {
        window.location.href = "http://app.shiminjia.com/library/questions/auth"
      }
    }
  },
  api: Api,
  GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.hash.substr(3).match(reg); //获取url中"?"符后的字符串并正则匹配
    var context = "";
    if (r != null)
      context = r[2];
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
  },
  getQueryVariable(variable) {
    // var query = window.location.search.substring(1);
    // var vars = query.split("&");
    // for (var i = 0; i < vars.length; i++) {
    //   var pair = vars[i].split("=");
    //   if (pair[0] == variable) { return pair[1]; }
    // }
    // return (false);
    const after = window.location.hash.split('?', 2)[1]
    if (after) {
      const reg = new RegExp('(^|&)' + variable + '=([^&]*)(&|$)')
      const r = after.match(reg)
      if (r != null) {
        return decodeURIComponent(r[2])
      } else {
        return false
      }
    }
  }
};

export default common;